import { mutationTypes } from '@/types';
import { generateUUID } from '@/tools/helpers';
export default {
	init() {
		if (this.$store.state.quiz.active) {
			collectQuestions.call(this, { addEventListener: true });
		}
	},
	positionUpdated() {
		if (this.$store.state.quiz.active && this.$store.state.quiz.visitedPages[this.articleID]) {
			this.$el.setAttribute('quiz-page-visited', true);
		} else {
			// uncheck input elements if container is reused from another quiz try
			this.$el.removeAttribute('quiz-page-visited');
			[
				...this.$el.querySelectorAll(
					'.element--singlechoice .element__radio, .element--multiplechoice .element__checkbox'
				),
			].forEach(inputElement => {
				inputElement.checked = false;
			});
			if (this.$store.state.quiz.active) {
				collectQuestions.call(this, { addEventListener: true });
			}
		}
	},
};
function collectQuestions({ addEventListener }) {
	const nameExtension = generateUUID();
	let questions = JSON.parse(JSON.stringify({ ...this.$store.state.quiz.questions }));
	[
		...this.$el.querySelectorAll(
			'.element--singlechoice .element__radio, .element--multiplechoice .element__checkbox'
		),
	].forEach(inputElement => {
		const post = inputElement.closest('.post');
		const postElement = inputElement.closest('.element');
		const questionID = post.getAttribute('post-id');
		const answerID = postElement.getAttribute('element-id');
		// extend name to prevent name clash of radiobuttons between article and content modal for quizresults
		if (inputElement.getAttribute('name')) {
			inputElement.setAttribute('name', `${inputElement.getAttribute('name')}-${nameExtension}`);
		}
		if (this.tourID == this.$store.state.quiz.current) {
			if (!questions[questionID]) {
				questions[questionID] = {
					questionText: post.querySelector('.element--text').textContent,
					answers: {},
					result: null,
				};
				post.setAttribute('quiz-answered-correct', false);
			} else {
				post.setAttribute('quiz-answered-correct', !!questions[questionID].result);
			}
			if (!questions[questionID].answers[answerID]) {
				// if question is not collected yest set default values
				questions[questionID].answers[answerID] = {
					answerSelected: false,
					answerCorrect: postElement.getAttribute('answer-correct') == 'true',
				};
			}
			inputElement.checked = questions[questionID].answers[answerID].answerSelected;
			postElement.setAttribute('quiz-answer-checked', questions[questionID].answers[answerID].answerSelected);
			if (addEventListener)
				inputElement.addEventListener('change', () => {
					let answersObj = {};
					post.querySelectorAll('.element--singlechoice, .element--multiplechoice').forEach(postElement => {
						answersObj[postElement.getAttribute('element-id')] = {
							answerSelected: postElement.querySelector('input').checked,
							answerCorrect: postElement.getAttribute('answer-correct') == 'true',
						};
					});
					this.$store.commit(mutationTypes.quizStoreResult, {
						questionID,
						answersObj,
					});
					// update attribute
					postElement.setAttribute('quiz-answer-checked', postElement.querySelector('input').checked);
					post.setAttribute('quiz-answered-correct', !!this.$store.state.quiz.questions[questionID].result);
				});
			// storeQestion(); // store question also on beginnging so it is calcualted event if user does not select something
		}
	});
	this.$store.commit(mutationTypes.quizCollectQuestions, { questions });
}
